<template>
  <div class="page-container">
    <div class="import-export-title primary-color import-export-title-margins">
      <v-icon color="secondary" class="arrow-back" @click="goBack()">arrow_back</v-icon>
      <span style="margin-left: 16px">Export attendees</span>
    </div>
    <v-select
      v-if="eventTemplateId"
      v-model="selectedEventId"
      :items="performanceDates"
      label="Performance"
      item-text="from"
      item-value="id"
      box
      style="max-width: 676px"
    />
    <div class="import-export-container import-export-container-margins">
      <div class="import-export-description-margins">
        You can export your attendees and all of their data here. Choose the appropriate format of
        the file depending on the purpose.
      </div>
      <div class="import-export-description-margins" style="margin-bottom: 0 !important">
        Choose format:
        <v-radio-group v-model="exportFormat">
          <v-radio color="primary" label="Excel" value="xlsx" />
          <v-radio color="primary" label="CSV" value="csv" />
        </v-radio-group>
      </div>
      <div class="import-export-buttons">
        <a
          download
          :href="`${serverURL}/files/events/${
            eventId ? eventId : selectedEventId
          }/export/attendees/${exportFormat}/${
            eventId ? visibleFields : theaterVisibleFields
          }/${token}`"
        >
          <main-button :disabled="disableExportingButton" depressed text="Export attendees" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { getVisibleFields, serverURL } from '@/utils'
import { getExportToken } from '@/http'
import { GET_EVENTS_BY_EVENT_TEMPLATE_ID } from '@/graphql/event.graphql'
import moment from 'moment/moment'

export default {
  name: 'theater-export-container',
  props: {
    eventTemplateId: {
      default: null,
      type: String,
    },
    eventId: {
      default: null,
      type: String,
    },
    organizationSlug: String,
  },
  data() {
    return {
      serverURL,
      token: undefined,
      exportFormat: 'xlsx',
      visibleFields: undefined,
      selectedEventId: null,
      performanceDates: [],
      disableExportingButton: false,
      theaterVisibleFields: JSON.stringify(['Attendee name', 'Email']),
    }
  },
  watch: {
    selectedEventId: {
      async handler(val) {
        this.disableExportingButton = true
        await this.getTokenAndVisibleFields(val)
        this.disableExportingButton = false
      },
    },
  },
  async created() {
    if (this.eventId) {
      await this.getTokenAndVisibleFields(this.eventId)
    }
  },
  methods: {
    async getTokenAndVisibleFields(eventId) {
      const { data } = await getExportToken(eventId)

      this.token = data.token
      const localStorageVisibleFields = getVisibleFields(eventId)
      this.visibleFields = JSON.stringify(
        localStorageVisibleFields.filter(field => !field.includes('/')),
      )
    },
  },
  apollo: {
    getEventsByEventTemplateId: {
      query: GET_EVENTS_BY_EVENT_TEMPLATE_ID,
      variables() {
        return {
          organizationSlug: this.organizationSlug,
          eventTemplateId: this.eventTemplateId,
        }
      },
      result({ data: { getEventsByEventTemplateId } }) {
        this.performanceDates = getEventsByEventTemplateId
          .map(p => {
            return { ...p, from: moment(p.from).format('DD.MM.YYYY u HH:mm') }
          })
        this.selectedEventId = this.performanceDates[0].id
      },
    },
  },
}
</script>

<style scoped></style>
